import React from 'react'
import { useNavigate } from 'react-router'

import { Button } from '@frame/ui-primitives/button'
import { P } from '@frame/ui-primitives/p'

import { routes } from '@frame/routes'

import { useDocumentsFlowContext } from '../../contexts/documents-flow-context'

type Props = {
  taskId: string
}

export function AlternativeMethodsAlert({ taskId }: Props) {
  const { hideW2s } = useDocumentsFlowContext()
  const navigate = useNavigate()

  const onClick = () => {
    navigate(`${routes.alternativeMethods}/${taskId}`)
  }

  return (
    <div className="flex flex-col items-start gap-4">
      <div className="flex flex-col items-start gap-3 self-stretch rounded-md bg-electric-200 p-4">
        <P className="font-semibold">No {hideW2s ? 'paystubs' : 'paystubs or W2s'} available?</P>
        <Button onClick={onClick}>Try alternative methods</Button>
      </div>
    </div>
  )
}
